import { decodeJwt } from 'jose';

export const isTokenValid = (token: string) => {
    if (!token) {
        return false;
    }
    return decodeJwt(token).exp * 1000 > Date.now();
};
